import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Component, EventEmitter, Inject, Input, OnInit, Output } from '@angular/core';
import { Router } from '@angular/router';
import { throwError } from 'rxjs';
import { catchError, finalize, retry } from 'rxjs/operators';
import { ConfigApiService } from 'src/app/services/config-api.service';
import { RedirectionService, Status } from 'src/app/services/redirection.service';
import { environment } from '../../../environments/environment';
import { InstructionModificationService } from '../../services/instruction-modification.service';
import { InstructionService } from '../../services/instruction.service';
import { PersistanceService } from '../../services/persistance.service';
import { StateService } from '../../services/state.service';
import { StudyNavigationService } from '../../services/study-navigation.service';
import { UtilsService } from '../../services/utils.service';
import { BgColor } from '../../shared/types';

@Component({
  selector: 'app-instruction-container-bg-mono',
  templateUrl: './instruction-container-bg-mono.component.html',
  styleUrls: ['./instruction-container-bg-mono.component.scss'],
  standalone: false
})
export class InstructionContainerBgMonoComponent implements OnInit {
  @Input() instruction = 'practice-baseline';
  @Input() route = 'dns';
  @Input() label: string;
  @Input() showConsent = false;
  @Input() section: string;
  @Input() showContinue = true;
  @Input() isPracticeIntro = false;
  @Input() isFinalPage = false;
  @Input() bgColor = 'mono';
  @Input() type: string;
  @Input() mode: string;
  // TODO:#code
  // eslint-disable-next-line @angular-eslint/no-output-on-prefix
  @Output() onClick = new EventEmitter();

  isValidBgColor = true;

  illustration;
  content;
  instructions;

  body: string;
  title: string;

  outroLabels: {
    before_link: string;
    in_link: string;
    after_link: string;
  };

  constructor(
    private navigation: StudyNavigationService,
    private modifyInstruction: InstructionModificationService,
    private persistanceService: PersistanceService,
    private stateService: StateService,
    private http: HttpClient,
    private utils: UtilsService,
    private instructionService: InstructionService,
    private redirectionService: RedirectionService,
    private configApiService: ConfigApiService,
    private router: Router,
    @Inject('BASE_URL') private baseUrl: string
  ) {}

  ngOnInit(): void {
    if (!this.label) {
      this.label = this.instructionService.getTranslationsForTerm('INSTRUCTION_CONTINUE_BUTTON');
    }

    this.outroLabels = this.instructionService.getTranslationsForTerm('OUTRO_FINISH_STUDY');

    this.instructions = this.instructionService.getInstructions('EN')[this.instruction];

    if (!this.showConsent) {
      this.title = this.instructions['title'];
      this.replacePlaceholders();
    }

    // const keys = this.getKeys();

    this.illustration = `${this.baseUrl}assets/images/keyboard/${this.instructions['illustration']}`;

    if (!this.utils.enumHasValue(BgColor, this.bgColor)) {
      this.isValidBgColor = false;
    }

    if (this.isFinalPage) {
      this.redirectionService
        .setStatus(Status.complete)
        .pipe(
          finalize(() => {
            // TODO: #noAgency perhabs navigation to speicfic site TBD.
            if (this.configApiService.getParams().RID !== this.configApiService.getParams().user)
              setTimeout(() => {
                window.location.href = environment.agencyCompleteURL.replace(
                  'XXX',
                  this.configApiService.getParams().RID
                );
              }, 5000);
            else {
              this.router.navigate(['/terminate'], {
                queryParams: { status: 'success' }
              });
            }
          })
        )
        .subscribe({
          next: () => sessionStorage.clear(),
          error: error => console.log('error', error)
        });
    }
  }

  get BgColor() {
    return BgColor;
  }

  navigateToNext() {
    if (this.isPracticeIntro) {
      this.onClick.emit();
      this.navigation.renderNext();
    }
  }

  replacePlaceholders() {
    this.body = this.modifyInstruction.replacePlaceholders(this.instructions['body'], this.instruction, this.section);
  }

  handleStudyFinish(e) {
    e.preventDefault();

    if (!this.isFinalPage) return;

    try {
      const httpOptions = {
        headers: new HttpHeaders({
          'Content-Type': 'application/json'
        })
      };

      const urlForBackendCall = `${environment.backendURL}${environment.endpointToAgency}`;
      const request = this.http.get<{ url: string }>(urlForBackendCall, httpOptions).pipe(
        retry(5),
        catchError(() => {
          return throwError('An error occurred when trying to redirect to agency');
        })
      );
      request.subscribe(
        res => {
          this.persistanceService.clearSessionStorage();

          const redirectUrl = res.url;
          window.location.replace(redirectUrl);
        },
        error => {
          throw new Error(error);
        }
      );
    } catch (error) {
      console.error(error);
    }
  }
}
